import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=523739fa&scoped=true"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSelect.vue?vue&type=style&index=0&id=523739fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523739fa",
  null
  
)

export default component.exports